import React from 'react'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'

export interface EmptyStateCardProps {
  icon: React.ReactNode
  message: string
  className?: string
}

/**
 * EmptyStateCard - Displays an empty state with icon and message
 * Used when there's no data to display
 */
export const EmptyStateCard: React.FC<EmptyStateCardProps> = ({ icon, message, className = '' }) => {
  return (
    <Box
      className={className}
      sx={{
        p: 6,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2
      }}
    >
      <Box
        sx={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          backgroundColor: INTERAX_COLORS.heritageBlue40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {icon}
      </Box>
      <Box
        component="p"
        sx={{
          fontSize: '16px',
          color: INTERAX_COLORS.typographyFont
        }}
      >
        {message}
      </Box>
    </Box>
  )
}
